import React from 'react';

import { Search, Text, cn } from 'Modules/ui';

import styles from './index.module.scss';


export const SearchInput = ({ className, ...inputProps }) => (
    <div className={cn(styles.search, className)}>
        <Text component='input' {...inputProps} />
        <Search />
    </div>
);
